import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import isChromatic from "chromatic";
import React, { Suspense } from "react";

import { CarouselLoadingSkeleton } from "@faire/retailer/components/SDUI/LoadingRenderers/Components/CarouselLoadingSkeleton";
import {
  IProps,
  LazySearchCategoryCarousel,
} from "@faire/retailer/components/SearchProducts/SearchCategoryCarousel";

export const BrandReviewsCarousel: React.FC<IProps> = (props) => {
  // -1500px = approx 75% down the page
  const renderThreshold = -1500;

  if (isPrerender() || isChromatic()) {
    return <SuspensedCarousel {...props} />;
  }

  if (props.brands.length === 0 && !props.isFetching) {
    return null;
  }

  return (
    <WhenVisibilityIsImminent
      customizePlaceholder={<CarouselLoadingSkeleton />}
      threshold={renderThreshold}
    >
      <SuspensedCarousel {...props} />
    </WhenVisibilityIsImminent>
  );
};

const SuspensedCarousel = (props: IProps) => (
  <Suspense fallback={<CarouselLoadingSkeleton />}>
    <LazySearchCategoryCarousel {...props} />
  </Suspense>
);
